/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetUsersLogoutQueryResponse, GetUsersLogout400 } from "../entities/GetUsersLogout";

function getGetUsersLogoutUrl() {
  const res = { method: 'GET', url: `/users/logout` as const }  
  return res
}

/**
 * @description User logout
 * @summary Logout
 * {@link /users/logout}
 */
export async function getUsersLogout(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetUsersLogoutQueryResponse, ResponseErrorConfig<GetUsersLogout400>, unknown>({ method : "GET", url : getGetUsersLogoutUrl().url.toString(), ... requestConfig })  
  return res.data
}